import { Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { Breadcrumb, BreadcrumbService } from '@core/services/breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.css',
  imports: [RouterLink]
})
export class BreadcrumbComponent implements OnInit {
  private breadcrumbService = inject(BreadcrumbService);

  breadcrumbs: Breadcrumb[] = [];

  ngOnInit(): void {
    this.breadcrumbService.breadcrumbs$.subscribe(crumbs => {
      this.breadcrumbs = crumbs;
    });
  }

  onBreadcrumbClick(crumb: Breadcrumb) {
    this.breadcrumbService.breadcrumbClick(crumb);
  }
}
